<template>
  <div class="w-full">
    <!-- <div class="seth-set bg-primary">
      <img
        src="@/assets/images/banh.png"
        class="object-cover h-100px w-full"
        alt="banh"
      />
      <div class="absolute top-0 py-10 w-full px-6 flex  items-center">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Attributes
          </h2>
        </div>
      </div>
    </div> -->
    <div class="mt-4 p-6">
      <div
        class="cust-shadow rounded-10px bg-white p-4 mb-4"
        v-for="item in EcomAttrinutes"
        :key="item"
      >
        <div
          class="w-full flex bg-white justify-between items-center px-4 py-3 rounded-lg"
        >
          <h3 class="fsize16 mb-0 text-black font-semibold">{{ item.name }}</h3>

          <!-- <div class="flex items-center gap-4">
            <feather-icon
              icon="Edit2Icon"
              class="cursor-pointer"
              svgClasses="w-5 h-5"
            />
            <feather-icon
              icon="TrashIcon"
              class="cursor-pointer"
              svgClasses="w-5 h-5"
            />
          </div> -->
        </div>

        <div class="px-4 mt-2 mb-4">
          <!-- <div>
            <input
              placeholder="Please type and click enter"
              v-model="input"
              class="borde-bot w-1/4 rounded-none"
            />
          </div> -->
          <div class="mt-4 grid grid-cols-9 gap-4">
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center bg-light-primary"
              v-for="val in item.attributeValueId"
              :key="val"
            >
              <h4 class="text-primary mb-0 fsize14 font-semibold">
                {{ val.attributeValue }}
              </h4>

              <!-- <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              /> -->
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="mt-6 cust-shadow rounded-10px bg-white p-4">
        <div
          class="w-full flex bg-white justify-between items-center px-4 py-3 rounded-lg"
        >
          <h3 class="fsize18 mb-0 text-black font-semibold">Size</h3>

          <div class="flex items-center gap-4">
            <feather-icon
              icon="Edit2Icon"
              class="cursor-pointer"
              svgClasses="w-5 h-5"
            />
            <feather-icon
              icon="TrashIcon"
              class="cursor-pointer"
              svgClasses="w-5 h-5"
            />
          </div>
        </div>

        <div class="px-4 mt-2 mb-4">
          <div>
            <input
              placeholder="Please type and click enter"
              v-model="input"
              class="borde-bot w-1/4 rounded-none"
            />
          </div>
          <div class="mt-4 grid grid-cols-9 gap-4">
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>

            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>

            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>

            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>

            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
            <div
              class="px-4 py-3 rounded-lg flex justify-between items-center light-purple"
            >
              <h4 class="text-primary mb-0 fsize16 font-semibold">Color</h4>

              <feather-icon
                icon="XIcon"
                class="cursor-pointer text-primary flex"
                svgClasses="w-5 h-5"
              />
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      input: "",
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {},
  computed: {
    ...mapState("EcomAttributes", ["EcomAttrinutes"]),
  },
};
</script>
